import Vue from 'vue'

const mixins = Vue.mixin({
  computed: {
    _() {
      return this.$store.state.wording;
    }
  },
  methods: {
    slugify(text, ampersand = 'and') {
      const a = 'àáäâèéëêìíïîòóöôùúüûñçßÿỳýœæŕśńṕẃǵǹḿǘẍźḧ'
      const b = 'aaaaeeeeiiiioooouuuuncsyyyoarsnpwgnmuxzh'
      const p = new RegExp(a.split('').join('|'), 'g')

      return text.toString().toLowerCase()
          .replace(/[\s_]+/g, '-')
          .replace(p, c =>
              b.charAt(a.indexOf(c)))
          .replace(/&/g, `-${ampersand}-`)
          .replace(/[^\w-]+/g, '')
          .replace(/--+/g, '-')
          .replace(/^-+|-+$/g, '')
    },
    newPage(pages, nextPage) {
      let Page = pages.find(page => page.id == nextPage);
      switch (Page.setting_page_type_id) {
        case 1: {
          if (this.$route.name === 'dynamic') return './' + Page.id;
          return 'dynamic/' + Page.id;
        }
        case 2: {
          if (this.$route.name === 'dynamic') return '../authors';
          return 'authors';
        }
        case 3: {
          if (this.$route.name === 'dynamic') return '../submit';
          return 'submit';
        }
        case 4: {
          if (this.$route.name === 'dynamic') return '../payment';
          return 'payment';
        }
      }
    },
    hasNewPage(pages, currentPage, nextPage) {
      let Page = pages.find(page => page.id == nextPage);
      if (!Page) {
        return false;
      }
      return true;
    },
    hasNextSite(pages, currentPage) {
      return this.hasNewPage(pages, Number(currentPage), Number(currentPage) + 1)
    },
    nextSite(pages, currentPage) {
      return this.newPage(pages, Number(currentPage) + 1)
    },
    hasPreviousSite(pages, currentPage) {
      return this.hasNewPage(pages, Number(currentPage), Number(currentPage) - 1)
    },
    previousSite(pages, currentPage) {
      if (!this.hasPreviousSite(pages, Number(currentPage))) {
        return '/home'
      }
      return this.newPage(pages, Number(currentPage) - 1)
    },
    containsKey(obj, key) {
      return Object.keys(obj).includes(key);
    },
    countryData() {
      let data = [];
      this.$store.state.countries.forEach((element, index) => {
        if (this.containsKey(this.$store.state.wording[0].country, element.iso_3166_alpha2)) {
          let cname = this.$store.state.wording[0].country[element.iso_3166_alpha2];
          data.push({'label': cname, 'id': element.iso_3166_alpha2})
        }
      });
      data.sort(function (a, b) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
      return data;
    },
    getAccountUrl() {
      return process.env.VUE_APP_AUTH_URL + 'application/' + process.env.VUE_APP_AUTH_KEY + '?profile=true';
    }
  }
});

export default mixins
